<template>
    <page>
        <module>
            <view-list
                ref="view"
                work-type="29"
                :view-config="saasInfo.viewmanage"
                selector
            >
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="盘点单号">
                            <c-input name="check_code" placeholder="请输入盘点单号"></c-input>
                        </m-search-item>
                        <m-search-item label="盘点人员">
                            <c-input name="check_user" placeholder="请输入盘点人员"></c-input>
                        </m-search-item>
                        <m-search-item label="盘点结果">
                            <c-select name="check_result" :options="checkResultOptions"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button color="main" v-if="auth('b_inventory_edit')" prepend-icon="tf-add"
                              @click="createInventory">创建盘点任务</c-button>
                    <c-button v-if="auth('b_inventory_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #otherOperate>
                    <c-button v-if="auth('b_inventory_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
                </template>

                <template #check_state="{data}">
                    <c-state dict="INVENTORY_STATE" tag :value="data.check_state"></c-state>
                </template>

                <template #check_result="{data}">
                    <span v-if="!data.check_result">{{'-'}}</span>
                    <c-state v-else dict="INVENTORY_RESULT" :value="data.check_result"></c-state>
                </template>

                <template #remark="{data}">
                        <template v-if="data.check_result == 2">[
                            <span :style="{color: '#e53e3e'}">盘亏{{data.loss_count || 0}}条，盘盈{{data.profit_count || 0}}条</span>
                            ]<template v-if="data.remark"> {{data.remark}}</template>
                        </template>
                        <template v-else>{{data.remark || '-'}}</template>
                </template>

                <c-table-column
                    type="button"
                    label="操作"
                    width="180"
                    button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_inventory_edit') && data.check_state == 1 && userInfo.id == data.create_user_id" icon="tf-edit" @click="editInventory(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_inventory_start') && data.check_state != 3 && (userInfo.id == data.create_user_id || userInfo.id == data.check_user_id)" icon="tf-stock" @click="startInventory(data)">开始盘点</c-table-button>
                        <c-table-button v-if="auth('b_inventory_edit') && data.check_state == 3" icon="tf-detail" @click="inventoryDetail(data)">详情</c-table-button>
                        <c-table-button v-if="auth('b_inventory_delete') && data.check_state == 1 && userInfo.id == data.create_user_id" icon="tf-trash" color="red" @click="deleteInventory(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>

            <!--创建/编辑盘点任务弹窗-->
            <inventory-edit ref="inventoryEdit" @resolve="$refs.view.update()"></inventory-edit>
            <!--盘点详情抽屉-->
            <inventory-detail ref="inventoryDetail" @resolve="$refs.view.update()"></inventory-detail>
        </module>
    </page>
</template>

<script>
    import {mapState} from 'vuex'
    import inventoryEdit from "@/pages/storage/inventory_edit.vue";
    import inventoryDetail from "@/pages/storage/inventory_detail.vue";

    export default {
        name: 'm_inventory_list',

        components: {inventoryEdit, inventoryDetail},

        computed: {
            ...mapState(['saasInfo', 'userInfo'])
        },

        data() {
           return {
               checkResultOptions: [
                   {name: '正常', value: 1},
                   {name: '异常', value: 2}
               ]
           }
        },

        methods: {
            loadWorkLogDetail(){
                //打开模板选择弹窗
                this.globalDialog('workLogDetail',{
                    props: {
                        workType: this.workType
                    }
                });
            },

            /*******创建盘点任务**********/
            createInventory() {
                this.$refs.inventoryEdit.open();
            },

            /*******编辑盘点任务**********/
            editInventory(data) {
                this.$refs.inventoryEdit.open(data);
            },

            /*******开始盘点**********/
            startInventory(data) {
                if (data.check_state == 1) {
                    this.request({
                        url: '/inventory/start',
                        data: {id: data.id},
                        // loading: true,
                        success: (res, msg) => {
                            this.$refs.view.update();
                            this.$refs.inventoryDetail.open(data.id);
                        }
                    });
                } else if (data.check_state == 2) {
                    this.$refs.inventoryDetail.open(data.id);
                }
            },

            inventoryDetail(data) {
                this.$refs.inventoryDetail.open(data.id);
            },

            /*******删除盘点任务**********/
            deleteInventory(data) {
                this.$confirm({
                    message: '确认删除盘点任务【' + data.check_code + '】？删除后不可恢复！',
                    buttonName: '确定删除',
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/inventory/delete',
                            data: {id: data.id},
                            loading: true,
                            success: (res, msg) => {
                                this.$message({message: msg, type: 'success'});
                                this.$refs.view.update();
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
</style>
